<!-- Asset Maintenance Dashboard -->

<template>
  <b-container fluid class="p-3">
    <!-- <b-row class="mb-3">
      <b-col class="d-flex align-items-center">
        <BackToMasters navName="" :goback="$router.back"></BackToMasters>
        <h6 class="mb-0">
          {{ t("assetManagement.maintenancedetails.heading") }}
        </h6>
      </b-col>
    </b-row> -->
    <b-row class="p-3" v-if="skeletonloading">
      <b-col lg="8" md="8" sm="12" cols="12">
        <div class="asset-stats-card">
          <Skeleton height="1.5rem" width="100%" class="mb-4"></Skeleton>
          <div class="d-flex justify-content-around">
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
          </div>
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" cols="12">
        <div class="asset-stats-card">
          <b-row>
            <b-col cols="6">
              <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
            </b-col>
            <b-col cols="6">
              <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
            </b-col>
            <b-col cols="6" class="mt-2">
              <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
            </b-col>
            <b-col cols="6" class="mt-2">
              <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="skeletonloading" />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col lg="8" md="8" sm="12" cols="12">
        <div class="asset-stats-card" v-if="!skeletonloading">
          <div class="stats-grid">
            <div class="stat-item">
              <i class="pi pi-database"></i>
              <span class="stat-label"
                >{{
                  t("assetManagement.maintenancedetails.TotalAssets")
                }}:</span
              >
              <span class="stat-value total">
                {{ DetailsData?.TotalAsset || 0 }}</span
              >
            </div>
            <div class="stat-item">
              <i class="pi pi-clock"></i>
              <span class="stat-label"
                >{{ t("assetManagement.maintenancedetails.Pending") }}:</span
              >
              <span class="stat-value assigned">{{
                DetailsData?.PendingMaintenance || 0
              }}</span>
            </div>
            <div class="stat-item">
              <i class="pi pi-exclamation-triangle"></i>
              <span class="stat-label"
                >{{ t("assetManagement.maintenancedetails.Overdue") }}:</span
              >
              <span class="stat-value unassigned">{{
                DetailsData?.Overdue || 0
              }}</span>
            </div>
            <div class="stat-item">
              <i class="pi pi-flag"></i>
              <span class="stat-label"
                >{{ t("assetManagement.maintenancedetails.Escalated") }}:</span
              >
              <span class="stat-value in-use">{{
                DetailsData?.Escalated || 0
              }}</span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" cols="12">
        <div class="asset-stats-card">
          <b-row>
            <!-- <b-col cols="6">
              <Button class="action-button">
                <i class="pi pi-chart-bar mr-2"></i>
                {{ t("assetManagement.maintenancedetails.analyticsreport") }}
              </Button>
            </b-col>
            <b-col cols="6">
              <Button class="action-button">
                <i class="pi pi-shopping-cart mr-2"></i>
                {{ t("assetManagement.maintenancedetails.orderspareparts") }}
              </Button>
            </b-col>
            <b-col cols="6" class="mt-2">
              <Button class="action-button">
                <i class="pi pi-history mr-2"></i>
                {{ t("assetManagement.maintenancedetails.vieworderhistory") }}
              </Button>
            </b-col> -->
            <b-col cols="6" class="mt-2">
              <Button class="action-button">
                <i class="pi pi-file-pdf mr-2"></i>
                {{ t("assetManagement.maintenancedetails.generatereports") }}
              </Button>
            </b-col>
            <b-col cols="6" class="mt-2">
              <Button
                class="action-button"
                @click="OpenSidebar('StartAdhoc', 'create')"
              >
                <i class="pi pi-file-pdf mr-2"></i>
                {{ t("assetManagement.maintenancedetails.adhoc") }}
              </Button>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col llg="12" md="12" sm="12" cols="12" class="mt-3">
        <b-form @submit.prevent="IsShow(tableStatus)">
          <b-row>
            <b-col cols="3">
              <div class="field">
                <label>{{ t("assetManagement.assetassign.assetId") }}</label>
                <AutoCompleteCustom
                  :rules="{ required: true }"
                  :required-icon="true"
                  :id="t('assetManagement.assetassign.assetId')"
                  v-model="FiltersObject.asset"
                  :items="FiltersObject.assetoptions"
                  @input="LoadAsset()"
                  @item-select="assetIdAssign"
                />
              </div>
            </b-col>

            <b-col cols="3">
              <div class="field">
                <CustomDropdown
                  :label="
                    t(
                      'assetManagement.maintenancedetails.Filters.maintenanceType'
                    )
                  "
                  v-model="FiltersObject.maintenanceType"
                  :items="FiltersObject.maintenanceTypeoptions"
                  :rules="{ required: true }"
                  :required-icon="true"
                  :id="
                    t(
                      'assetManagement.maintenancedetails.Filters.maintenanceType'
                    )
                  "
                  :name="
                    t(
                      'assetManagement.maintenancedetails.Filters.maintenanceType'
                    )
                  "
                />
              </div>
            </b-col>
            <!-- <b-col cols="3">
            <div class="field">
              <CustomDropdown :label="$t('assetManagement.maintenancedetails.Filters.status')"
                v-model="FiltersObject.status" :name="$t('assetManagement.maintenancedetails.Filters.status')"
                :id="$t('assetManagement.maintenancedetails.Filters.status')" :items="FiltersObject.statusoptions" />
            </div>
          </b-col>
          <b-col cols="3">
            <div class="field">
              <CustomDropdown :label="$t('assetManagement.maintenancedetails.Filters.warranty')
                " v-model="FiltersObject.warranty" :name="$t('assetManagement.maintenancedetails.Filters.warranty')
                  " :id="$t('assetManagement.maintenancedetails.Filters.warranty')"
                :items="FiltersObject.warrantyoptions" />
            </div>
          </b-col> -->
            <b-col>
              <div class="d-flex flex-row-reverse mt-4">
                <Footer
                  @cancel="clearFilter"
                  label="Filter"
                  :cancelhide="true"
                  :loading="filterLoading"
                />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
      <b-col lg="12" md="12" sm="12" xs="12" class="position-relative">
        <div class="btnPosition">
          <Button
            v-for="tab in tabs"
            :key="tab"
            @click="setActiveTab(tab)"
            :class="['mx-1 btnTab', activeTab === tab ? 'btnactiveTab' : '']"
          >
            {{ tab }}
          </Button>
        </div>
      </b-col>
      <b-col>
        <Tableview
          :value="list"
          :paginator="true"
          class="p-datatable-gridlines commonstatusclass"
          :rows="10"
          :rowHover="true"
          filterDisplay="menu"
          responsiveLayout="scroll"
          :columns="filteredHeaders"
          @row-click=""
          :globalFilterFields="globalFilterFields"
          :filters="filters"
          @ShowRows=""
          :exceldownload="true"
          :filterbtn="true"
          :statusFilterBtn="true"
        >
          <template v-slot:status="{ data }">
            <OrangeStatus name="InActive" v-if="data.Status == '0'" />
            <GreenStatus name="Active" v-if="data.Status == '1'" />
          </template>
          <template v-slot:EscalationStatus="{ data }">
            <OrangeStatus
              name="Escalated"
              v-if="data.EscalationStatus == 'Escalated'"
            />
            <GreenStatus
              name="OnSchedule"
              v-if="data.EscalationStatus == 'OnSchedule'"
            />
          </template>
          <template v-slot:action="{ data }">
            <span>
              <Button
                icon="pi pi-ellipsis-v"
                class="p-button-rounded editicon p-button-text"
                @click="toggle($event, data)"
              />
            </span>
          </template>
        </Tableview>
      </b-col>
    </b-row>
  </b-container>
  <Menu ref="menu" id="overlay_menu" :model="actionlist" :popup="true" />
  <AssetMaintenanceRightSidebar
    :trigger="CommonObject.sidebaropen"
    :sidebarheading="CommonObject.sidebarheading"
    :type="CommonObject.type"
    :tableId="tableId"
    @closedetailsrightsidebar="CloseSidebar()"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import BackToMasters from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import AssetMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import AssetMaintenanceService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMaintenanceService";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import AssetMaintenanceRightSidebar from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetMaintenanceDashboard/AssetMaintenanceRightSidebar.vue";
import { UserData } from "../../../../../../../../../MOPUI/src/types/auth";
import AutoCompleteCustom from "../../../../../../../components/FormComponents/AutoComplete.vue";
import MaintenanceScheduleMasterServices from "../../../../../Service/AssetManagement/MaintenanceScheduleMasterService";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";

export default defineComponent({
  components: {
    BackToMasters,
    SkeletonTableLoader,
    Tableview,
    CustomDropdown,
    AssetMaintenanceRightSidebar,
    AutoCompleteCustom,
    Footer,
  },

  setup() {
    const { t } = useI18n();
    const skeletonloading = ref(false);
    const router = useRouter();
    const routes = useRoute();
    const DetailsData = ref();
    const tableId = ref();
    const menu = ref();
    const list = ref<any[]>([]);
    const tabs = ["Pending", "Assign", "Completed"];
    const activeTab = ref("Pending"); // default active tab
    const hideEscalate = ref(false);
    const scheduleActionShow = ref(true);
    const assignActionShow = ref(false);
    const completeActionShow = ref(false);
    const filterLoading = ref(false);
    const tableStatus = ref(0);
    const setActiveTab = (tab) => {
      activeTab.value = tab;
      if (tab == "Pending") {
        scheduleActionShow.value = true;
        assignActionShow.value = false;
        completeActionShow.value = false;
        tableStatus.value = 0;
        IsShow(tableStatus.value);
      } else if (tab == "Assign") {
        scheduleActionShow.value = false;
        assignActionShow.value = true;
        completeActionShow.value = false;
        tableStatus.value = 1;
        IsShow(tableStatus.value);
      } else if (tab == "Completed") {
        scheduleActionShow.value = false;
        assignActionShow.value = false;
        completeActionShow.value = true;
        tableStatus.value = 2;
        IsShow(tableStatus.value);
      }
    };
    const ParamValues = ref({
      StoreId: Number(routes.query.Id ?? 0),
      BranchId: Number(routes.query.BranchId ?? 0),
    });

    let FiltersObject: any = ref({
      asset: "",
      assetId: 0,
      assetoptions: [],
      maintenanceType: 0,
      maintenanceTypeoptions: [],
      status: 0,
      statusoptions: [],
      warranty: 0,
      warrantyoptions: [],
    });

    let CommonObject = ref({
      sidebaropen: false,
      sidebarheading: "",
      type: "",
    });

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let SessionRoleData = localStorage.getItem("RolesData");
    let RolesData;
    if (SessionRoleData !== null) {
      RolesData = JSON.parse(SessionRoleData);
    }
    let isAdmin = usersData.Admin;
    const headers = ref([
      {
        header: t("assetManagement.maintenancedetails.dashboardtable.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t(
          "assetManagement.maintenancedetails.dashboardtable.assetname"
        ),
        field: "AssetName",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        header: t(
          "assetManagement.maintenancedetails.dashboardtable.maintenanceType"
        ),
        field: "MaintenanceType",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t(
          "assetManagement.maintenancedetails.dashboardtable.lastmaintenance"
        ),
        field: "LastMaintenanceDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t(
          "assetManagement.maintenancedetails.dashboardtable.nextmaintenance"
        ),
        field: "NextMaintenanceDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      // {
      //   header: t("assetManagement.maintenancedetails.dashboardtable.status"),
      //   field: "Status",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "smallwidth",
      //   slot: "status",
      //   fieldDisplay: "false"
      // },
      {
        header: t(
          "assetManagement.maintenancedetails.dashboardtable.escalationstatus"
        ),
        field: "EscalationStatus",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "EscalationStatus",
        fieldDisplay: "false",
        showInTabs: ["Pending"],
      },
      // {
      //   header: t("assetManagement.maintenancedetails.dashboardtable.warranty"),
      //   field: "warranty",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "smallwidth",
      // },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ]);
    const filteredHeaders = computed(() => {
      return headers.value.filter((h) => {
        // if no showInTabs → show everywhere
        if (!h.showInTabs) return true;
        return h.showInTabs.includes(activeTab.value);
      });
    });

    const globalFilterFields = ref(headers.value.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      assetName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      maintenanceType: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      lastMaintenance: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      nextMaintenance: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      status: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      warranty: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
    };

    const toggle = (event, data) => {
      tableId.value = data.Id;
      hideEscalate.value = data.EscalationStatus == "Escalated" ? true : false;
      menu.value.toggle(event);
    };

    const actionlist = computed(() => [
      {
        items: [
          {
            label: "View",
            icon: "pi pi-eye",
            visible: true,
            command: async () => {
              OpenSidebar("View", "get");
            },
          },
          {
            label: "Start Adhoc",
            icon: "pi pi-bolt",
            visible: scheduleActionShow.value,
            command: async () => {
              OpenSidebar("StartAdhoc", "get");
            },
          },
          {
            label: "Assign",
            icon: "pi pi-user-plus",
            visible: scheduleActionShow.value,
            command: async () => {
              OpenSidebar("Assign", "get");
            },
          },
          {
            label: "Perform Maintenance",
            icon: "pi pi-user-plus",
            visible: assignActionShow.value,
            command: async () => {
              OpenSidebar("PerformMaintenance", "get");
            },
          },
          // {
          //   label: "Escalate",
          //   icon: "pi pi-arrow-up",
          //   visible: (scheduleActionShow.value || assignActionShow.value) && hideEscalate.value,
          //   command: async () => {
          //     OpenSidebar("Escalate","get");
          //   },
          // },
          {
            label: "Schedule",
            icon: "pi pi-calendar-plus",
            visible: scheduleActionShow.value,
            command: async () => {
              OpenSidebar("Schedule", "get");
            },
          },
        ],
      },
    ]);
    onMounted(() => {
      LoadIMaintenanceScheduleMaster();
      IsDashnoardShow();
      IsShow(tableStatus.value);
    });

    async function IsDashnoardShow() {
      debugger;
      try {
        skeletonloading.value = true;
        const dataresponse =
          await AssetMaintenanceService.getListAssetMaintenanceDashboard(
            usersData.OrganizationId,
            usersData.BranchId,
            ParamValues.value.StoreId
          );
        DetailsData.value = dataresponse["result"];
        skeletonloading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    async function IsShow(status) {
      debugger;
      try {
        let roleId;
        if (isAdmin !== 1) {
          roleId = RolesData.RoleId;
        } else {
          roleId = 0;
        }
        let count = 0;
        skeletonloading.value = true;
        const dataresponse =
          await AssetMaintenanceService.getAssetMaintenanceSchedule(
            status,
            roleId,
            FiltersObject.value.assetId,
            FiltersObject.value.maintenanceType,
            FiltersObject.value.status,
            FiltersObject.value.warranty
          );
        list.value = dataresponse["result"].map((item) => {
          count = count + 1;
          const nextDate = new Date(item.NextMaintenanceDate);
          console.log("nextDate", nextDate);
          const today = new Date();
          console.log("today", today);
          // Add RowNumber
          item.RowNumber = count;
          // Add Status column
          if (!nextDate || isNaN(nextDate)) {
            item.EscalationStatus = "Escalated"; // or whatever default
          } else {
            item.EscalationStatus =
              nextDate < today ? "Escalated" : "OnSchedule";
          }
          return item;
        });
        skeletonloading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    //Load Item Autocomplete
    async function LoadAsset() {
      try {
        const data_response = await AssetMasterService.getAssetIdbyAutoComplete(
          FiltersObject.value.asset,
          usersData.HospitalId,
          usersData.BranchId,
          ParamValues.value.StoreId
        );
        console.log(data_response);
        FiltersObject.value.assetoptions = data_response["result"]
          // .filter((item) => item.StatusID == 1)
          .map((item) => {
            item.label = item.BarCode + "/" + item.AssetName;
            item.value = item.AssetId;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    async function LoadIMaintenanceScheduleMaster() {
      debugger;
      try {
        const response: AxiosResponse<MaintenanceScheduleMasterData> =
          await MaintenanceScheduleMasterServices.getdata();

        FiltersObject.value.maintenanceTypeoptions = response["result"].map(
          (item) => {
            item.name = item.MaintenanceType;
            item.value = item.Id;
            return item;
          }
        );
      } catch (error) {
        alert(error);
      }
    }
    function OpenSidebar(sidebarheading, type) {
      debugger;
      CommonObject.value.sidebaropen = true;
      CommonObject.value.sidebarheading = sidebarheading;
      CommonObject.value.type = type;
    }

    function CloseSidebar() {
      CommonObject.value.sidebaropen = false;
      CommonObject.value.type = "";
    }
    function assetIdAssign(data) {
      FiltersObject.value.assetId = data.value.AssetId;
    }
    function clearFilter() {
      FiltersObject.value.asset = "";
      FiltersObject.value.assetId = 0;
      FiltersObject.value.maintenanceType = 0;
      FiltersObject.value.status = 0;
      FiltersObject.value.warranty = 0;
      IsShow(tableStatus.value);
    }

    return {
      skeletonloading,
      ParamValues,
      t,
      DetailsData,
      headers,
      filteredHeaders,
      globalFilterFields,
      list,
      filters,
      FiltersObject,
      CommonObject,
      CloseSidebar,
      toggle,
      menu,
      actionlist,
      tabs,
      activeTab,
      setActiveTab,
      LoadAsset,
      tableId,
      hideEscalate,
      scheduleActionShow,
      assignActionShow,
      completeActionShow,
      filterLoading,
      tableStatus,
      clearFilter,
      IsShow,
      assetIdAssign,
      OpenSidebar,
    };
  },
});
</script>

<style scoped>
.btnTab {
  all: unset;
  background-color: #ffffff;
  color: #4361ee;
  border-radius: 5px;
  border: 1px solid #e1e1e1;
  padding: 10px 12px;
}

.btnPosition {
  position: absolute;
  top: 15px;
  left: 20px;
  display: flex;
  z-index: 9;
}

.btnactiveTab {
  background-color: #4361ee;
  color: #ffffff;
}

.action-button {
  width: 100%;
  height: 100%;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  padding: 0.55rem 1rem !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
  text-align: left !important;
  font-size: 0.85rem !important;
  background-color: #e7e7e7 !important;
  border-color: #e9e9e9 !important;
  color: #444 !important;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2) !important;
}

.action-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.action-button i {
  margin-right: 0.5rem !important;
  font-size: 1rem !important;
}
</style>
